import React from "react";
import Box from "@mui/material/Box";
import ExpandCircleDownIcon from "@mui/icons-material/ExpandCircleDown";
import IconButton from "@mui/material/IconButton";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ImageCounter from "../../../components/images/ImageCounter";

import {getBackgroundImage} from "../../../utils/images";
import {isPdf} from "../../../utils/fileTypes";

export default function ImagesSlider({ list, index, onChangeIndex }) {
  const handlePrev = e => {
    e.stopPropagation();
    onChangeIndex(prevState => (prevState === 0 ? list.length - 1 : prevState - 1));
  };

  const handleNext = e => {
    e.stopPropagation();
    onChangeIndex(prevState => (prevState + 1 >= list.length ? 0 : prevState + 1));
  };

  return (
    <>
      {list.length > 0 && (
        <>
          <ImageCounter index={index} total={list.length} />
          <Box
            top="calc(50% - 25px)"
            width="100%"
            position="absolute"
            display="flex"
            justifyContent="space-between"
          >
            {list.length > 1 ? (
              <IconButton onClick={handlePrev}>
                <ExpandCircleDownIcon
                  fontSize="large"
                  sx={{ color: "#333", transform: "rotate(90deg)" }}
                />
              </IconButton>
            ) : (
              <div />
            )}
            {list.length > 1 && (
              <IconButton onClick={handleNext}>
                <ExpandCircleDownIcon
                  fontSize="large"
                  sx={{ color: "#333", transform: "rotate(-90deg)" }}
                />
              </IconButton>
            )}
          </Box>
        </>
      )}
      <Box
        width="100%"
        height="0"
        pb="80%"
        sx={{
          backgroundImage: list.length && !isPdf(list[index])
            ? getBackgroundImage(list[index]?.url, "width", 600)
            : undefined,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundPosition: "center",
          backgroundColor: "#f4f6f8",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "16px",
        }}
      >
        {list.length > 0 && isPdf(list[index]) && (
          <Box 
            display="flex" 
            flexDirection="column" 
            alignItems="center" 
            gap={1}
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            <PictureAsPdfIcon sx={{ fontSize: 50, color: "#706E6B" }} />
            <Box sx={{ color: "#666", fontSize: 15 }}>
              Select to view attached PDF
            </Box>
          </Box>
        )}
      </Box>
    </>
  );
}
